var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testv__post__date__wrapper"},[_c('span',{staticClass:"testv__post__date"},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.date * 1000)))]),_c(_vm.icon,{tag:"component",staticClass:"testv__post__icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }